module.exports = __webpack_public_path__ + "static/media/Eighty.22545034.ogg";